import type {Integration} from "@sentry/core";

import * as Dev from "./dev-api.ts";

/**
 * Sentry integration to pass events to the mobile app.
 */
export function mobileAppSentryIntegration(): Integration {
    return {
        name: "MobileAppSentryIntegration",
        processEvent(event, hint, client) {
            // We aren't going to change the event, we're just going to log
            // any exceptions it references.
            if (event.exception?.values?.length) {
                for (const exception of event.exception.values) {
                    if (exception.value) {
                        Dev.error(exception.value, exception.stacktrace);
                    }
                }
            }

            // Return the event, untouched.
            return event;
        },
    };
}
